import { BaseProxy, type ProxyMethods } from '@/proxies/Proxy'

export default class ReportsProxy extends BaseProxy implements ProxyMethods {
  public endpoint = 'reports'
}
